import React from 'react'

export const TabInitiator: React.FC = () => {
    return <>TabInitiator</>
}
